import { Nullable } from 'types';

/** Contains various funnel flows through the app. */
export enum Funnel {
  Subscription = 'SUBSCRIPTION',
  Demo = 'DEMO',
  AIMusicGenerator = 'AI_MUSIC_GENERATOR',
  Remixer = 'REMIXER',
  DISTRIBUTION = 'DISTRIBUTION',
  LIBRARY = 'LIBRARY',
  ACCOUNT = 'ACCOUNT',
  RELEASES = 'RELEASES',
}

export interface Funnelable {
  funnelsForPathname(pathname: string): Nullable<Funnel[]>;
}

export type LocationInfo = {
  pathname: string;
  funnels: Funnel[];
};

export type DynamicLocationInfo = {
  pathname: (...params: string[]) => string;
  route: string;
  funnels: Funnel[];
};

export type SongDetailsLocationInfo = {
  pathname: (id: string, songName: string, isAIGenerated?: boolean) => string;
  route: string;
  funnels: Funnel[];
};
